import React from 'react';
import Button, { VARIANTS } from './Button';

const AltButton = props => <Button variant={VARIANTS.ALT} {...props} />;

export default AltButton;
